import { render, staticRenderFns } from "./Workspaces.vue?vue&type=template&id=53402052"
import script from "./Workspaces.vue?vue&type=script&setup=true&lang=js"
export * from "./Workspaces.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Workspaces.vue?vue&type=style&index=0&id=53402052&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports